var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComniqaiSmalllogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9855 24.5742C65.5628 24.5742 79.7257 38.1871 79.7259 51.7993V59.1062C77.4796 54.3137 73.3071 48.7894 67.7873 44.4191C62.9265 40.5704 58.197 38.8674 54.1842 38.2426C52.843 37.8932 51.4353 37.7068 49.9847 37.7068C48.0947 37.7069 46.2782 38.0232 44.5855 38.6048C43.4498 38.8858 42.8084 39.149 42.7953 39.1545L42.8002 39.1602C43.2348 39.0138 43.6772 38.8836 44.1255 38.7711C37.8448 41.1399 33.3769 47.2056 33.3769 54.3154C33.3771 63.4877 40.8125 70.9229 49.9847 70.9232C56.1038 70.9232 61.4485 67.613 64.3293 62.6866C64.0177 67.608 62.4885 74.9615 56.5999 79.6671C53.7901 81.9119 50.729 83.3486 46.9707 83.3486C33.3769 83.3486 21.2135 70.8356 20.3047 56.2133C19.2308 38.9282 32.9319 24.5745 49.9855 24.5742Z",
    fill: "url(#paint0_linear_10283_5345)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.5484 31.754C26.6499 37.626 25.4539 46.0444 33.3779 57.4769C33.3779 57.4769 29.6247 39.3406 41.2903 31.6078C47.8596 27.2525 55.0546 26.3638 60.0872 26.4181C56.8861 25.2071 53.4719 24.5215 49.9859 24.5215C42.5547 24.5206 35.7615 27.2483 30.5484 31.754Z",
    fill: "#35029C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.72 68.9583L57.7116 68.955C55.4024 70.1718 52.7766 70.8675 49.9855 70.8675C42.971 70.8675 36.9854 66.513 34.5509 60.3645L34.5384 60.3603C34.5384 60.3603 28.8618 48.871 33.0635 39.113C36.7257 30.6077 41.4109 26.6984 46.6014 24.7148C31.161 26.4645 19.3025 40.0334 20.3047 56.1586C20.5386 59.9269 21.4932 63.5122 23.0282 66.7802C26.6846 70.2745 31.0073 72.7408 35.4237 73.6344C51.9114 76.9734 57.72 68.9583 57.72 68.9583Z",
    fill: "url(#paint1_linear_10283_5345)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M57.7202 68.9602L57.7119 68.9568C57.0028 69.3302 56.2612 69.6475 55.4979 69.9181C51.8248 71.9283 46.175 72.9431 37.8142 70.8694C29.4609 68.7982 23.4761 62.9988 20.7627 59.7617C21.2262 62.2188 21.9912 64.5739 23.0285 66.7829C26.6848 70.2772 31.0076 72.7434 35.4239 73.6371C51.9117 76.9752 57.7202 68.9602 57.7202 68.9602Z",
    fill: "#022C90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M34.5512 60.3665L34.5387 60.3623C34.5387 60.3623 28.8621 48.873 33.0638 39.115C36.726 30.6097 41.4112 26.7003 46.6017 24.7168C44.0536 25.0058 41.6058 25.6221 39.2949 26.5132C31.183 31.834 27.9802 40.8045 30.2318 51.7409C33.1348 65.8418 42.4426 69.0597 42.4426 69.0597L42.446 69.0513C38.869 67.219 36.042 64.1322 34.5512 60.3665Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1621 43.5488L61.1688 43.5589C65.3444 47.3183 65.762 53.1644 66.5938 57.6009C66.5938 57.8156 66.5695 58.0235 66.562 58.2357L66.5938 58.2849V78.9334C66.5938 81.3412 68.5455 83.2938 70.9541 83.2938H79.7258C79.7258 83.2938 79.7258 80.3531 79.7258 71.538C73.3736 45.7423 61.1621 43.5488 61.1621 43.5488Z",
    fill: "url(#paint2_linear_10283_5345)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.9212 60.1356C67.8539 48.9328 62.8221 44.4866 61.88 43.755C61.6946 43.6106 61.1729 43.5605 61.1729 43.5605C63.0127 46.2314 64.9271 47.0576 66.1797 54.0001C66.1797 54.2147 66.1555 54.9914 66.148 55.2035L66.1797 55.2528L66.5928 78.9343C66.5928 81.342 68.5446 83.2946 70.9532 83.2946H79.7249C74.926 81.2694 70.199 73.55 68.9212 60.1356Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M58.0125 68.7851C57.9114 68.8411 57.8146 68.9021 57.7118 68.9564L57.7202 68.9597C57.7202 68.9597 51.9125 76.9747 35.4239 73.6366C31.0076 72.7421 26.6848 70.2767 23.0285 66.7824C22.9458 66.6062 24.8424 71.0392 29.1318 75.4481C33.3652 77.0883 39.3442 77.931 45.6521 76.3784C54.2593 74.2596 57.1005 70.8171 58.0125 68.7851Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.623 22.566C66.623 18.9398 69.5628 16 73.1891 16C76.8153 16 79.7551 18.9398 79.7551 22.566C79.7551 26.1923 76.8153 29.1321 73.1891 29.1321C69.5628 29.1321 66.623 26.1923 66.623 22.566Z",
    fill: "url(#paint3_linear_10283_5345)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9986 20.3225C77.9986 23.9488 75.0588 26.8886 71.4325 26.8886C69.8541 26.8886 68.4059 26.3307 67.2734 25.4028C68.3324 27.6076 70.5798 29.1326 73.1889 29.1326C76.8152 29.1326 79.7549 26.1929 79.7549 22.5666C79.7549 20.5188 78.817 18.6906 77.348 17.4863C77.7605 18.3465 77.9986 19.3053 77.9986 20.3225Z",
    fill: "#35029C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10283_5345",
    x1: 20.2461,
    y1: 54.3147,
    x2: 79.7265,
    y2: 54.3147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35029C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2578,
    stopColor: "#38049E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4268,
    stopColor: "#4009A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5704,
    stopColor: "#4F13B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6997,
    stopColor: "#6520BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8194,
    stopColor: "#8031D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9305,
    stopColor: "#A145EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA55FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10283_5345",
    x1: 32.7869,
    y1: 27.0515,
    x2: 40.9831,
    y2: 74.4721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64EBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1103,
    stopColor: "#5CC5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2592,
    stopColor: "#5298D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4093,
    stopColor: "#4A73CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5585,
    stopColor: "#4356C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7064,
    stopColor: "#3F41C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8525,
    stopColor: "#3C35BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#3B31BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10283_5345",
    x1: 64.2822,
    y1: 38.4852,
    x2: 75.7957,
    y2: 83.7591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1374,
    stopColor: "#FAC90D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3352,
    stopColor: "#F89C1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    stopColor: "#F6792B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7037,
    stopColor: "#F56034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#F4503A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#F44B3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10283_5345",
    x1: 73.1892,
    y1: 14.2878,
    x2: 73.1892,
    y2: 68.3606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA55FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1532,
    stopColor: "#B552FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3319,
    stopColor: "#A749F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5234,
    stopColor: "#903BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7239,
    stopColor: "#6F26C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9295,
    stopColor: "#450CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35029C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComniqaiSmalllogo);
export default __webpack_public_path__ + "static/media/comniqai-smalllogo.701728b423d68208b7b16029c0e589ce.svg";
export { ForwardRef as ReactComponent };